export const FACEBOOK_API_VERSION = 2.9;
export const MESSAGES = {
  noPageSelected: {
    type: 'blocker',
    message:
      'No page has been selected for this app. Select only one Facebook page linked to your Instagram account.',
  },
  multiplePages: {
    type: 'blocker',
    message:
      'Multiple pages have been selected for this app. Select only one Facebook page linked to your Instagram account.',
  },
  invalidInstagramAccount: {
    type: 'blocker',
    message: 'No Instagram account selected/linked to the Facebook page.',
  },
  permissionsDenied: {
    type: 'warning',
    message:
      'Enable all mandatory permissions for the app to function properly.',
  },
  resetFailed: {
    type: 'blocker',
    message: 'Reset failed',
  },
  loggedin: {
    type: 'success',
    message: 'Successfully Connected to your Facebook account',
  },
};
